import { DataSource } from '@/shared/models/data/data-source'
import { ResourceViewModel } from '@/business/resource/interfaces/resource-view-model'
import { PageResponse } from '@/shared/interfaces/page-response'
import { Injector } from '@/config/dependency-injection'
import { ExtendedBlob } from '@/shared/models/extended-blob'
import { ResourceType } from '@/business/resource/interfaces/resource-type'
import { ResourceModule } from '@/business/resource/store/resource-module'
import { ResourceVariantViewModel } from '@/business/resource/interfaces/resource-variant-view-model'

export class ResourceDialogDataSource extends DataSource<ResourceViewModel> {
  private loading = false

  private resourceModule = Injector.get(ResourceModule)

  get items(): ResourceViewModel[] {
    return this.resourceModule.data.resources
  }

  public createResource(file: ExtendedBlob): Promise<ResourceViewModel> {
    return this.resourceModule.createResource({
      file,
      resource: {
        name: file.name,
        type: ResourceType.FILE,
      },
    })
  }

  public createVariant(
    file: ExtendedBlob,
    resource: ResourceViewModel
  ): Promise<ResourceVariantViewModel> {
    return this.resourceModule.createVariant({
      file,
      resource: {
        description: resource.description,
        name: resource.name,
        originalId: resource.id,
        type: resource.type,
      },
    })
  }

  public destroy(): void {
    this.resourceModule.clearResources()
  }

  public fetchData(): Promise<PageResponse<ResourceViewModel>> {
    this.loading = true

    return this.resourceModule
      .fetchResources({
        page: 1,
        pageSize: 1000,
      })
      .finally(() => {
        this.loading = false
      })
  }

  public isLoading(): boolean {
    return this.loading
  }
}
